import './DetailsJournal.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchUpdates } from "../../../slices/updatesSlice";

import { Timeline } from "../../../common-components/Timeline/Timeline";

const DetailsJournal = ({departureId, token}) => {
    const dispatch = useDispatch();
    const { columns, data, loadingStatus } = useSelector((state) => state.updates);

    useEffect(() => {
        dispatch(fetchUpdates({ departureId, token }));
    }, [dispatch, token, departureId]);

    if (loadingStatus === "loading") {
        return <div>Загрузка...</div>;
    }

    if (loadingStatus === "error") {
        return <div>Ошибка загрузки данных</div>;
    }

    return (
        <div className={"details-journal"}>
            <div className={"details-journal_container"}>
                <Timeline columns={columns} data={data}/>
            </div>
        </div>
    )
}

export default DetailsJournal;